//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      tab: 'Meeting',
      notice: []
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.tab = to.name
      vm.getNotice()
      vm.$emit('on-view-loaded', vm.today)
      if (to.name === 'Study') {
        vm.goTab('Meeting')
      }
      if (vm.$isWechat()) {
        let shareLink = window.location.href
        let shareDesc = ''
        let shareImage = null
        vm.$wechatShare(shareLink, shareLink, to.meta.title, shareDesc, shareImage)
      }
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.tab = to.name
    next()
  },
  computed: {
    today () {
      let today = new Date()
      return this.$dateFormat(today, 'YYYY年M月D日') + ' ' + this.$week(today)
    }
  },
  methods: {
    goTab (tab) {
      if (this.tab === tab) {
        this.$refs.studyView.loadList(true)
      } else {
        this.$router.push({name: tab})
      }
    },
    getNotice () {
      this.$get('notice/list', (res) => {
        if (res.code === 200) {
          this.notice = res.data
        } else {
          this.notice = []
        }
      })
    },
    viewNotice (url) {
      document.location.href = url
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/Study.vue